module.exports = [{"title":"Kostprobe","slogan":"Lassen Sie sich begeistern","good":["2 Nuterkonten"],"bad":["Branding"]},{"title":"Core","slogan":"Das Wichtigste zusammengefasst","good":["2 Nuterkonten"],"bad":["Branding"]},{"title":"Enterprise","slogan":"Die Lösung für Ihr Unternehmen","good":["2 Nuterkonten"],"bad":["Branding"]}]


//////////////////
// WEBPACK FOOTER
// ./src/constants/tarifs.json
// module id = 694
// module chunks = 2